import React from 'react';
import { useHistory } from 'react-router-dom';
import { Footer, Wrap } from '../Tool';
import { Header } from '../Tool/Header';
import img404 from '../../../img/404.png';
const NotFound = React.memo((props) => {
    const history = useHistory();
    // トップに戻る
    const handleBack = () => {
        history.push('/tool/top');
    };
    return (React.createElement(Wrap, { addClasses: ['bg-tool'] },
        React.createElement(React.Fragment, null,
            React.createElement(Header, null),
            React.createElement("main", { className: "flex-grow h-full overflow-y-auto overflow-x-hidden mb-8" },
                React.createElement("div", { className: "flex items-center mt-24" },
                    React.createElement("div", { className: "w-full flex justify-center" },
                        React.createElement("img", { src: img404 })))),
            React.createElement(Footer, null))));
});
export default NotFound;
